import type { ClassificationResult, GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Text, MultiSelect, Badge, BadgeSize } from '@soteria/design-system-ve';

import { LikeDislikeButtons } from '../../LikeDislikeButtons/LikeDislikeButtons';
import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

interface LabelsSectionProps {
  selectedItem: GraphQLAuditItem | null;
  correctedLabels: string[];
  labelOptions: Array<{ id: string; value: string; label: string }>;
  filterOptionsLoading: boolean;
  isSessionCompleted: boolean;
  labelsCorrect: boolean | null;
  onCorrectedLabelsChange: (selectedValues: string[]) => void;
  onLabelsCorrectChange: (value: boolean) => void;
  getClassificationResults: (item: GraphQLAuditItem | null) => ClassificationResult[];
  className?: string;
}

export function LabelsSection({
  selectedItem,
  correctedLabels,
  labelOptions,
  filterOptionsLoading,
  isSessionCompleted,
  labelsCorrect,
  onCorrectedLabelsChange,
  onLabelsCorrectChange,
  getClassificationResults,
  className,
}: LabelsSectionProps) {
  return (
    <div className={className || spacingStyles.sectionContainer}>
      <Text className={styles.sectionTitle}>Label Assessment</Text>
      <div className={spacingStyles.flexRowSpaceBetween}>
        <Text className={styles.assessmentQuestion}>Do you agree with the original labels?</Text>
        <LikeDislikeButtons disabled={isSessionCompleted} name="labels-assessment" value={labelsCorrect} onChange={onLabelsCorrectChange} />
      </div>
      <div className={spacingStyles.flexColumnGap}>
        <div>
          <Text className={styles.originalLabelsTitle}>Original Labels:</Text>
          <div className={styles.labelBadges}>
            {getClassificationResults(selectedItem).map((result: ClassificationResult) => (
              <Badge key={`${result.name}-${result.severity}`} size={BadgeSize.Small} text={`${result.name.toUpperCase()} ${result.severity}`} />
            ))}
          </div>
        </div>
        <div>
          <Text className={styles.correctedLabelsTitle}>Corrected Labels:</Text>
          <MultiSelect
            searchable
            disabled={filterOptionsLoading || isSessionCompleted}
            options={labelOptions}
            placeholder={filterOptionsLoading ? 'Loading labels...' : 'Select corrected labels...'}
            searchPlaceholder="Search labels..."
            selectedValues={correctedLabels}
            onSelectionChange={onCorrectedLabelsChange}
          />
        </div>
      </div>
    </div>
  );
}
